export enum ECameraMode {
  ECM_None,
  ECM_FirstPerson,
  ECM_ThirdPerson,
}
